
if (!customElements.get('slick-component')) {
    customElements.define(
        'slick-component',
        class SlickComponent extends HTMLElement {
            constructor() {
                super()
                this.slickObj = { mobileFirst: true }
                this.resizeHandler = null
                this.breakpoints = this.getAttribute('breakpoints')
                    .split('|')
                    .map((breakpoint) => breakpoint.split('-'))

                const attributes = Object.values(this.attributes)
                    .filter((attribute) => attribute.name.includes('slick-'))
                    .map((attribute) => {
                        attribute.slick_name = attribute.name
                            .split('slick-')[1]
                            .replace(/(_\w)/g, (m) => m[1].toUpperCase())
                        if (attribute.value.includes('|')) return attribute
                        this.slickObj[attribute.slick_name] = this.parseValue(attribute.value)
                        return null
                    })
                    .filter(Boolean)

                this.slickObj.responsive = this.breakpoints.map((breakpoint, index) => ({
                    breakpoint: parseInt(breakpoint[0]),
                    settings: breakpoint[1] === 'slick'
                        ? Object.assign({}, ...attributes.map((attribute) => ({
                            [attribute.slick_name]: this.parseValue(attribute.value.split('|')[index])
                        })))
                        : 'unslick'
                }))


                this.initSlider()

            }

            parseValue(value) {
                if (isNaN(value)) {
                    return /^(true|false)$/i.test(value)
                        ? value.toLowerCase() === 'true'
                        : value
                }
                return Number(value)
            }

            disconnectedCallback() {
                this.cleanup()
            }

            cleanup() {
                if (this.resizeHandler) {
                    window.removeEventListener('resize', this.resizeHandler)
                    this.resizeHandler = null
                }
                if (this.slickInstance) {
                    $(this).slick('unslick')
                    this.slickInstance = null
                }
            }

            initSlider(reinit = false) {
                if (reinit) {
                    this.cleanup()
                }

                $(this).slick(this.slickObj)
                this.slickInstance = $(this).slick('getSlick')

                if (!window.design_mode &&
                    this.breakpoints.length > 1 &&
                    this.getAttribute('breakpoints')?.includes('unslick')) {

                    this.resizeHandler = this.handleResize.bind(this)
                    window.addEventListener('resize', this.resizeHandler)
                }
            }

            handleResize() {
                if (!this.slickInstance) return

                const width = window.innerWidth
                const currentBreakpoint = this.slickInstance.activeBreakpoint
                const nextBreakpoint = this.slickObj.responsive
                    .find(bp => bp.breakpoint > width)?.breakpoint

                if (nextBreakpoint !== currentBreakpoint) {
                    this.initSlider(true)
                }
            }
        }
    )
}